<template>
  <div class="main main__container register-user-container">
    <h1 class="h1-bold">
      {{ declineInvite ? t('declineRegisterUserHeader') : t('registerUserHeader') }}
    </h1>
    <template v-if="declineInvite">
      <oie-form-wrapper class="information-island inputs-container" @submit="handleDeclineInvite">
        <template v-if="!declinedSuccessfully">
          <div class="body-smaller" v-html="t('declineRegisterUserInfoText')">
          </div>
          <oie-action-wrapper>
            <oie-base-action type="submit" size="large" theme="destructive">
              {{ t('declineRegisterUserButton') }}
            </oie-base-action>
          </oie-action-wrapper>
        </template>
        <div v-else v-html="t('declineSuccessfullyMessage')">
        </div>
      </oie-form-wrapper>
    </template>
    <template v-else-if="notValid">
      <oie-form-wrapper class="information-island inputs-container">
        <div v-html="notValidInfoText">
        </div>
      </oie-form-wrapper>
    </template>
    <validation-observer v-else ref="observer" slim>
      <oie-form-wrapper class="information-island inputs-container" @submit="handleCreateUser">
        <div class="body-smaller" v-html="t('registerUserInfoText')">
        </div>

        <validation-provider
          v-slot="{errors}"
          rules="required"
          slim>
          <oie-base-input
            v-model="user.firstName"
            :label-text="`${tStatic('firstNameLabel')}*`"
            :placeholder="tStatic('firstNamePlaceholder')"
            :max-length="80"
            :error-messages="errors"></oie-base-input>
        </validation-provider>
        <validation-provider
          v-slot="{errors}"
          rules="required"
          slim>
          <oie-base-input
            v-model="user.lastName"
            :label-text="`${tStatic('lastNameLabel')}*`"
            :placeholder="tStatic('lastNamePlaceholder')"
            :max-length="80"
            :error-messages="errors"></oie-base-input>
        </validation-provider>
        <validation-provider
          v-slot="{errors}"
          rules="required|numeric"
          slim>
          <oie-base-input
            v-model="phone"
            name="phone"
            autocomplete="tel-national"
            :label-text="`${tStatic('phoneLabel')}*`"
            :placeholder="tStatic('phonePlaceholderLabel')"
            :max-length="27"
            :error-messages="errors"
            :prefix-value="selectedActiveCountry ? selectedActiveCountry.callingCode : null"></oie-base-input>
        </validation-provider>
        <validation-provider
          v-slot="{errors}"
          vid="pw"
          rules="required|passwordPolicy"
          slim>
          <oie-base-input
            v-model="user.password"
            autocomplete="new-password"
            type="password"
            :label-text="`${tStatic('password')}*`"
            :placeholder="tStatic('passwordPlaceholder')"
            :error-messages="errors"></oie-base-input>
        </validation-provider>

        <validation-provider v-slot="{errors}" rules="required|password:pw" slim>
          <oie-base-input
            v-model="reEnteredPassword"
            type="password"
            autocomplete="new-password"
            :label-text="`${tStatic('passwordMatch')}*`"
            :placeholder="tStatic('passwordMatchPlaceholder')"
            :error-messages="errors"></oie-base-input>
        </validation-provider>
        <oie-action-wrapper>
          <oie-base-action type="submit" size="large">
            {{ t('registerUserButton') }}
          </oie-base-action>
        </oie-action-wrapper>
      </oie-form-wrapper>
    </validation-observer>
  </div>
</template>

<script>
import countryHandling from '@/mixins/country-handling'
import httpService from '@/core/http-service'
import utils from '@/core/utils'

export default {
  mixins: [countryHandling],
  props: {
    userId: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    declineInvite: {
      type: Boolean,
      default: false
    },
    notValid: {
      type: Boolean,
      default: false
    },
    notValidInfoText: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      user: {
        firstName: '',
        lastName: '',
        mobile: '',
        password: ''
      },
      reEnteredPassword: '',
      declinedSuccessfully: false

    }
  },
  computed: {
    phone: {
      get() {
        return this.selectedActiveCountry ? utils.extractPhoneNumberFromFormating(this.user.mobile, this.selectedActiveCountry.callingCode) : this.user.mobile
      },
      set(value) {
        this.selectedActiveCountry ? this.user.mobile = utils.savePhoneNumberWithFormating(value, this.selectedActiveCountry.callingCode) : this.user.mobile = value
      }
    }
  },
  async beforeMount() {
    if(this.defaultCountry) this.setActiveCountry(this.defaultCountry.value)
  },
  methods: {
    async handleCreateUser() {
      const isValid = await this.$refs.observer.validate()
      if(isValid) {
        httpService.post('auth/invite/createuser', { ...this.user, token: this.token }).then((response) => {
          window.location = response.data.url
        }).catch(() => {
        })
      }
    },
    async handleDeclineInvite() {
      httpService.post('auth/invite/decline', { token: this.token }).then((response) => {
        this.declinedSuccessfully = true
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="scss">
.register-user-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: measure(half);

  @include media('medium') {
    gap: measure(full);
  }
}
</style>
